import { render, staticRenderFns } from "./CohortListAddNew.vue?vue&type=template&id=4d0a78d3&"
import script from "./CohortListAddNew.vue?vue&type=script&lang=js&"
export * from "./CohortListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CohortListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports